import React from "react";

export const ModalLoadingContext = React.createContext({ confirmLoading: false });

export const WalletContext = React.createContext(null);

export const OperationContext = React.createContext(null);
